import {
  Button,
  Divider,
  Grid,
  GridList,
  GridListTile,
  withWidth,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import ourWork from "../../static/ourWork";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: "100vh",
    fontFamily: "Nunito",
    background: theme.palette.background.paper,
    overflow: "hidden",
  },
  grid: {
    width: "100%",
    margin: theme.spacing(0),
  },
  title: {
    fontFamily: "Nunito",
    fontSize: "2.5rem",
    color: theme.palette.primary.main,
    textAlign: "center",
  },
  picTitles: {
    fontFamily: "Nunito",
    fontSize: "2.5rem",
    textAlign: "left",
    margin: theme.spacing(2),
  },
  pictureGrid: { width: "100%", margin: theme.spacing(0) },
  card: {
    borderRadius: 12,
  },
  cardMedia: {
    height: 275,
  },
  paper: {
    padding: theme.spacing(0.5),
    margin: "auto",
  },
  img: {
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
}));

const OurWork = (props) => {
  const classes = useStyles();

  const { setCurrPage, width } = props;

  useEffect(() => {
    setCurrPage("Our Work");
  }, [setCurrPage]);

  let columns = width === "xs" || width === "sm" ? 1 : 4;

  return (
    <div className={classes.root}>
      <Grid
        className={classes.grid}
        container
        direction="column"
        alignItems="center"
        justify="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <div
            style={{
              textAlign: "center",
              marginTop: "10px",
              marginBottom: "5px",
            }}
          >
            <h1>Take A Look at Some of Our Work</h1>
            <Divider style={{ marginTop: "5px", marginBottom: "15px" }} />
            <h2>Follow us on Instagram to See More!</h2>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: "20px", marginBottom: "5px" }}
              size="small"
              href="https://www.instagram.com/candr.extservices_jax/"
              target="_blank"
            >
              <h2>Click to Follow &gt;</h2>
            </Button>
          </div>
        </Grid>
        <Grid item xs={7} className={classes.grid}>
          <GridList cellHeight={100} cols={columns} spacing={15}>
            {ourWork.map((work) => (
              <GridListTile key={work.imageURL} cols={work.cols || 1} rows={2}>
                <img
                  src={work.imageURL}
                  alt={work.title}
                  className={classes.img}
                />
              </GridListTile>
            ))}
          </GridList>
        </Grid>
      </Grid>
    </div>
  );
};
export default withWidth()(OurWork);
